<template>
  <!-- topic -->
  <div >
    <div >
      <div class="mb10">
        <v-button class="" type="primary" name="" @click="showNewModel">创建Topic</v-button>
      </div>
      <div>
        <vxe-table
          row-id="id"
          :data="table"
          align="left"
          :row-style="setRowClass"
        >
          <vxe-table-column  field="topic" show-overflow min-width="320" title="topic"></vxe-table-column>
          <vxe-table-column  field="created_at" show-overflow min-width="120" title="创建时间"></vxe-table-column>
          <vxe-table-column  field="updated_at" show-overflow min-width="120" title="更新时间"></vxe-table-column>
          <vxe-column title="操作" min-width="120">
              <template v-slot="slotProps">
                <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDelModel(slotProps.row)">删除</v-button></span>
              </template>
          </vxe-column>
        </vxe-table>
      </div>
      <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage" ></v-pagination>
    </div>

    <New :showInputDialog.sync="Newloading" ref="New" @getData="getData" :sourceId="sourceId"></New>
    <Del :showInputDialog.sync="Delloading" ref="Del" @getData="getData" :Id="Id" ></Del>
  </div>
</template>

<script>
import New from "@/components/rule-engine/topic/new-topic.vue";
import Del from "@/components/rule-engine/topic/del.vue";

export default {
components: {New, Del},
props:{
  sourceId:{
    type: Number
  }
 },
data() {
  return {
    Newloading:false,
    Delloading: false,
    Id: '',
    table: [],
    currentPage: 1,
    pageSize: 10,
    total: 0,
  };
},
created() {
  this.getData()
},
methods: {
  setRowClass({rowIndex}){
   if( rowIndex%2!==0){
      return "background: #fafafa";
   }
  },
  async getData(){
    const subData = {
      app_id: sessionStorage.getItem("appid") || "",
      page_num: this.currentPage,
      page_size: this.pageSize,
      source_id: this.sourceId
    };
    const res = await this.$getData(
      "/td/td-iot-api/iot/rule/topic/list/v1",
      subData
    );
    if(res.code === 0){
      this.table = res.data.list
      this.total = res.data.total
    }else{
      if(res.code == '100410'){
        setTimeout(() => {
          this.getData()
        },1000)
      }else{
        this.$message.error(res.msg);
      }
    }
  },
  changePage(page){
    this.currentPage = Number(page)
    this.getData()
  },
  changeSize(size){
    this.pageSize = Number(size)
    this.currentPage = 1
    this.getData()
  },
  showNewModel(){
    this.Newloading = !this.Newloading
  },
  showDelModel(row){
    this.Id = row.id
    this.Delloading = !this.Delloading
  },
},
beforeDestroy() {},
};
</script>
<style lang="scss">
  .low-title{
    font-size: 18px;
  }
</style>
